import { addCommas } from '@/utils/checkdata.js';
export const itemList ={

    data(){
        return{
            isLoading:true,
            items:'1234'
        }
    },
    mounted(){
        this.fetchItems();
    },
    computed:{
        itemLists:{
            get(){
                return this.$store.state.item.items;
            }
        },
    },
    methods:{
        goItemBuy(id,isMobile)
        {
            if(isMobile ==='isMobile')
            {
                this.$router.push('/m/item/view/'+id);
            }else{
                this.$router.push('/main/item/view/'+id);   
            }
            
        },
        addCom(val)
        {
            return addCommas(val);
        },
        async fetchItems() {
            const formData = {
                data:1
            }
            try {
                const response = await this.$store.dispatch("item/fetchItems", formData)
                //console.log(response);
                this.items = response.data;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },

    }
}
